import React from "react";
// Imports SVG for the empty state illustration
import Empty1 from "../../../assets/media/svg/empty_1.svg";
import Empty2 from "../../../assets/media/svg/empty_2.svg";
import Empty3 from "../../../assets/media/svg/empty_3.svg";
import Empty4 from "../../../assets/media/svg/empty_4.svg";
import Empty5 from "../../../assets/media/svg/empty_5.svg";
import Empty6 from "../../../assets/media/svg/empty_6.svg";
import Empty7 from "../../../assets/media/svg/empty_7.svg";
import Cta from "@components/Cta/Cta.tsx";
import useDevice from "../../helpers/useDevice.ts";

// Define props interface
interface EmptyProps {
  message?: string;
  figure?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
}

/**
 * Empty Component
 * Displays an illustration and a message when there are no results.
 *
 * @component
 * @param {EmptyProps} props - Component props.
 * @returns {JSX.Element} - Rendered empty state component.
 */
const Empty: React.FC<EmptyProps> = ({
  message = "Nenhum resultado encontrado",
  figure = 3,
}: EmptyProps): JSX.Element => {
  // Array of illustrations
  const images = [Empty1, Empty2, Empty3, Empty4, Empty5, Empty6, Empty7];

  // Validate figure index and select appropriate image
  const SelectedImage = images[figure - 1];

  const { device } = useDevice();

  return (
    <div
      className="tool-block__component__results__empty"
      aria-label={message}
      role="img"
    >
      <SelectedImage />
      {device === "desktop" && <Cta />}
    </div>
  );
};

export default Empty;
